import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SchoolBuildingIcon = createIcon({
  displayName: 'SchoolBuildingIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <line
        x1="1.99999"
        y1="21"
        x2="21.99999"
        y2="21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="8.49999"
        y1="16.955"
        x2="15.49999"
        y2="16.955"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="11.99999"
        y1="17"
        x2="11.99999"
        y2="21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3,21V14a1,1,0,0,1,1-1H6"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M18,13h2a1,1,0,0,1,1,1v7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="14.99999"
        y1="17"
        x2="14.99999"
        y2="21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="8.99999"
        y1="21"
        x2="8.99999"
        y2="17"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M6,21V10.85714a1,1,0,0,1,.50386-.86824l5-2.85714a1,1,0,0,1,.99228,0l5,2.85714A1,1,0,0,1,18,10.85714V21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="11.99999"
        y1="4.5"
        x2="11.99999"
        y2="7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect
        x="11.99999"
        y="2"
        width="4"
        height="3"
        rx="0.5"
        strokeWidth="1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11.82262,11.07382l.00044-.00043a.24665.24665,0,1,1-.00044.00043"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const SchoolBuilding: FC<IconProps> = (props) => {
  return <CustomIcon as={SchoolBuildingIcon} {...props} />
}

export default memo(SchoolBuilding)
